export function useTemplate() {
  function round(x) {
    if (x) return Math.round(x)
    return null
  }

  function fixed2(x) {
    if (x) return x.toFixed(2)
    return null
  }

  function fixed3(x) {
    if (x) return x.toFixed(3)
    return null
  }

  function toHex(data) {
    if (data.startsWith("VGlueUdTLXRlc3Q"))
      return "TinyGS Test Packet";
    if (data.startsWith("RXJyb3JfQ1JD"))
      return "CRC ERROR";
    
    // Buffer puede no estar disponible en navegador, usar atob como fallback
    let decodedData;
    try {
      if (typeof Buffer !== "undefined") {
        decodedData = Buffer.from(data, 'base64');
      } else {
        const binary = atob(data);
        decodedData = new Uint8Array([...binary].map(c => c.charCodeAt(0)));
      }
    } catch (e) {
      return "Invalid Data";
    }
    
    let packetData = "";
    for (let i = 0; i < decodedData.length; i++) {
      if (decodedData[i] <= 0xF) { packetData += "0"; }
      packetData += decodedData[i].toString(16);
    }
    return packetData;
  }

  return {
    round,
    fixed2,
    fixed3,
    toHex
  }
}